import CheckCircleBroken from "@/assets/icons/check-circle-broken.svg";
import { useTranslation } from "react-i18next";

const TreatedTag = () => {
    const { t } = useTranslation();

    return (
        <div className="text-main-title flex w-auto items-center gap-1 rounded-full border bg-success-base/10 p-1 px-1.5 text-xs">
            <img alt="Treated" className="h-4 w-4" src={CheckCircleBroken} />
            {t("emails.treated")}
        </div>
    );
};

export default TreatedTag;
